import { createRouter, createWebHistory } from 'vue-router';

import Login from '../pages/Login.vue';
import ClinicsList from '../pages/Clinics/Clinics.vue';
import ClinicsEdit from '../pages/Clinics/ClinicsEdit.vue';
import UsersList from '../pages/Users/Users.vue';
import UsersRegister from '../pages/Users/UsersRegister.vue';
import UsersEdit from '../pages/Users/UsersEdit.vue';
import OrgList from '../pages/Organization/Organization.vue';
import OrgRegister from '../pages/Organization/OrganizationRegister.vue';
import OrgEdit from '../pages/Organization/OrganizationEdit.vue';
import AuditList from '../pages/Audits/Audits.vue';
import Integrations from '../pages/Integrations/Integrations.vue';
import Dashboard from '../pages/Dashboard/Dashboard.vue'
import Error from '../pages/Error.vue';
import { useAuthStore } from '@/stores/authStore';
import LoginAudits from '../pages/LoginAudits/LoginAudits.vue';
import Artifact from '../pages/Artifacts/Artifact.vue';
import HealthPings from '../pages/HealthPings/HealthPings.vue';
import Onboarding from '../pages/Onboarding/Onboarding.vue';
import BulkSetup from '../pages/Setup/BulkSetup.vue';
import Feedback from '../pages/Feedback/Feedback.vue';
import StateHealthOrgList from '../pages/StateAccess/StateHealthOrgList.vue';
import StateHealthOrgEdit from '../pages/StateAccess/StateHealthOrgEdit.vue';
import StateComparison from '../pages/Comparison/StateComparison.vue';
import StateDashboard from '../pages/StateOrg/StateDashboard.vue';
import StateClinicComparison from '../pages/StateOrg/StateClinicComparison.vue';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: Onboarding,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
      allowedRoles: ['admin']
    }
  },
  {
    path: '/bulk-setup',
    name: 'bulk-setup',
    component: BulkSetup,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      allowedRoles: ['admin']
    }
  },
  {
    path: '/clinics',
    name: 'clinics-list',
    component: ClinicsList,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
    }
  },
  {
    path: '/clinics/edit/:id',
    name: 'clinics-edit',
    component: ClinicsEdit,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
    }
  },
  {
    path: '/users',
    name: 'users-list',
    component: UsersList,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
    }
  },
  {
    path: '/users/register',
    name: 'users-register',
    component: UsersRegister,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
    }
  },
  {
    path: '/users/edit/:id',
    name: 'users-edit',
    component: UsersEdit,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
      //allowedRoles: ['clinic_admin']
    }
  },
  {
    path: '/org',
    name: 'org-list',
    component: OrgList,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
      allowedRoles: ['admin']
    }
  },
  {
    path: '/org/register',
    name: 'org-register',
    component: OrgRegister,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
      allowedRoles: ['admin']
    }
  },
  {
    path: '/org/edit/:id',
    name: 'org-edit',
    component: OrgEdit,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
      allowedRoles: ['admin']
    }
  },
  {
    path: '/audits',
    name: 'audits',
    component: AuditList,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
      allowedRoles: ['admin']
    }
  },
  {
    path: '/integrations',
    name: 'integrations',
    component: Integrations,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
      allowedRoles: ['admin']
    }
  },
  {
    path: '/login-audits',
    name: 'login-audits',
    component: LoginAudits,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
      allowedRoles: ['admin']
    }
  },
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
    }
  },
  {
    path: '/state-benchmark',
    name: 'state-benchmark',
    component: StateComparison,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      allowedRoles: ['admin']
    }
  },
  {
    path: '/state-dashboard',
    name: 'state-dashboard',
    component: StateDashboard,
    meta: {
      requiresAuth: true,
      allowedRoles: ['state_health_org']
    }
  },
  {
    path: '/state-clinic-comparison',
    name: 'state-clinic-comparison',
    component: StateClinicComparison,
    meta: {
      requiresAuth: true,
      allowedRoles: ['state_health_org']
    }
  },
  {
    path: '/artifact',
    name: 'artifact',
    component: Artifact,
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true, 
      allowedRoles: ['admin']
    }
  },
  {
    path: '/health-pings',
    name: 'HealthPings',
    component: HealthPings,
    meta: {
      requiresAuth: true,
      allowedRoles: ['admin'] // Assuming only admins should access this page
    }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: Feedback,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      allowedRoles: ['admin']
    }
  },
  {
    path: '/state-access',
    name: 'state-access-list',
    component: StateHealthOrgList,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      allowedRoles: ['admin']
    }
  },
  {
    path: '/state-access/register',
    name: 'state-access-register',
    component: StateHealthOrgEdit,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      allowedRoles: ['admin']
    }
  },
  {
    path: '/state-access/edit/:id',
    name: 'state-access-edit',
    component: StateHealthOrgEdit,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      allowedRoles: ['admin']
    }
  },
  {
    path: '/:catchAll(.*)*',
    name: 'error',
    component: Error, // Catch-all route for 404 or unauthorized access
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  await authStore.initializeSession();

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAuthenticated = authStore.isAuthenticated;

  if (to.name === 'login' && isAuthenticated) {
    if (authStore.userRole === 'state_health_org') {
      next({ name: 'state-dashboard' });
      return;
    }
    next({ name: 'dashboard' });
    return;
  }

  if (!requiresAuth) {
    next();
    return;
  }

  const hasValidSession = await authStore.ensureValidSession();
  if (!hasValidSession) {
    authStore.logout();
    next('/login');
    return;
  }

  if (!authStore.userRole) {
    try {
      await authStore.fetchUserDetails({ force: true });
    } catch (error) {
      console.error('Unable to fetch user details during navigation.', error);
      authStore.logout();
      next('/login');
      return;
    }
  }

  const allowedRoles = to.meta.allowedRoles || null;
  if (allowedRoles && !allowedRoles.includes(authStore.userRole)) {
    if (authStore.userRole === 'state_health_org') {
      next({ name: 'state-dashboard' });
      return;
    }
    next('/');
    return;
  }

  if (to.meta.requiresAdmin && !['admin', 'clinic_admin'].includes(authStore.userRole)) {
    if (authStore.userRole === 'state_health_org') {
      next({ name: 'state-dashboard' });
      return;
    }
    authStore.logout();
    next('/login');
    return;
  }

  next();
});



export default router;
